const withTrailingSlash = (value) => {
    if (!value) {
        return '';
    }
    return value.endsWith('/') ? value : `${value}/`;
};

const fromServerUrl = process.env.REACT_APP_SERVER_URL
    ? `${process.env.REACT_APP_SERVER_URL.replace(/\/$/, '')}/api/`
    : '';

export const API_BASE = withTrailingSlash(process.env.REACT_APP_API || fromServerUrl);
